// extracted by mini-css-extract-plugin
export default {"largeBottomPadding":"Privacy_largeBottomPadding__X1J5s","textCenter":"Privacy_textCenter__R5I2C","additionalTermsContainer":"Privacy_additionalTermsContainer__nRq6P"};